import { Link } from 'react-router-dom';
import { navbarLinks, contactInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-flower-line text-primary-400 text-2xl"></i>
              </span>
              <span className="text-lg font-heading font-semibold text-background-50">樱境物语</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              以樱花为主题的沉浸式叙事体验，<br />
              带你走进唯美的樱境世界，<br />
              感受物语之美。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navbarLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <a href={`mailto:${contactInfo.email}`} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                <i className="ri-mail-line mr-2"></i>{contactInfo.email}
              </a>
              <span className="text-sm text-background-400">
                <i className="ri-weibo-line mr-2"></i>{contactInfo.weibo}
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-wechat-line mr-2"></i>{contactInfo.wechat}
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="TapTap">
                <i className="ri-gamepad-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 樱境物语 Sakura Monogatari. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}